import React from "react";
import ISkill from "./interfaces/ISkill";

const Skill = ({ index, header, body, tags }: ISkill) => (
  <article className="skill-card">
    <span className="skill-index">{index}</span>
    <h3>{header}</h3>
    <p>{body}</p>
    <ul className="tag-list">
      {tags.map((tag) => (
        <li key={tag}>{tag}</li>
      ))}
    </ul>
  </article>
);

export default Skill;
